<template>
  <div
    data-testid="tag-component"
    :class="[
      $slots.icon ? 'flex space-x-2' : '',
      bgColourClass,
      'inline-flex',
      'items-center',
      'px-6',
      'py-2.5',
      'rounded-full',
    ]"
    :title="title"
    role="status"
    :aria-label="`${label}, ${title}`"
  >
    <slot name="icon">
    </slot>
    <span
      data-testid="tag-label"
      class="text-lg font-bold text-royal-blue-160">{{
        label
      }}</span>
  </div>
</template>

<script>
export default {
  name: 'TagComponent',
  props: {
    label: {
      type: String,
      required: true,
    },
    bgColour: {
      type: String,
      default: 'default',
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    bgColourClass() {
      switch (this.bgColour) {
        case 'royal-blue-10':
          return 'bg-royal-blue-10'
        case 'lemon':
          return 'bg-lemon'
        case 'bright-lime-60':
          return 'bg-bright-lime-60'
        case 'science-blue-20':
          return 'bg-science-blue-20'
        case 'lilac':
          return 'bg-lilac'
        case 'ruby-red-20':
          return 'bg-ruby-red-20'
        case 'peach-orange':
          return 'bg-peach-orange'
        default:
          return 'bg-royal-blue-10'
      }
    },
  },
}
</script>
